const QUERY_NOT_FOUND =
    'Nie znaleziono żadnych wyników spełniających kryteria wyszukiwania. Spróbuj wpisać inną frazę.';
const SEARCH_RESULTS_NOT_FOUND =
    'Nie znaleziono żadnych wyników spełniających kryteria wyszukiwania. Spróbuj zmienić zakładkę wyników lub zaznaczone filtry';

export const MESSAGES = {
    SEARCH_RESULTS_NOT_FOUND,
    QUERY_NOT_FOUND,
};
